import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { InvoiceHeader, InvoiceOrganization, InvoicePlace } from '../../models/invoice';
import { Observable, of } from 'rxjs';
import { Member } from '../../models';
import { ExternalMember } from '../../models/member/external-member.model';

/**
 * Service containing tools for converting the data of anything into information relevant to invoicing
 */
@Injectable()
export class InvoicingService {

  readonly process: string = 'DKX';
  readonly validTypes = ['TRAINING', 'BOOKING', 'LUNCH', 'OTHER'];

  getInvoiceableNumber(owner: Member | ExternalMember): Observable<InvoiceOrganization | InvoicePlace> {
    if (owner.hasOwnProperty('thirdNumber')) {
      return of(new InvoiceOrganization({jdeNumber: (owner as ExternalMember).thirdNumber}));
    }

    return of(new InvoicePlace({costCenter: owner.getShortCodeCenter()}));
  }

  /**
   * Return an invoice Header with its basis informations
   *
   * @return InvoiceHeader
   */
  getInvoiceHeader() {
    return new InvoiceHeader({
      documentType: 'INVOICE',
      referenceNumber: uuid(),
      dates: {
        operationDate: new Date().toISOString(),
      },
    });
  }
}
